import { JsonProperty } from "./json-property";

export class LocalTimeRead {
    
    @JsonProperty({ toType: 'datetime'})
    public utc : Date = new Date();

    @JsonProperty({ toType: 'datetime-specific'})
    public local : Date = new Date();

    public timeZone : string = '';

}
